<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'page', params: {} }">
            Page
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'pageView', params: {} }">
              View Page
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Page
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="page.label">
            <td max-width="35%" class="text-subtitle-1">Label:</td>
            <td>{{ page.label }}</td>
          </tr>
          
          <tr v-if="page.endpoint">
            <td max-width="35%" class="text-subtitle-1">Endpoint:</td>
            <td>{{ page.endpoint }}</td>
          </tr>
          
          <tr v-if="page.endpoint_module">
            <td max-width="35%" class="text-subtitle-1">Endpoint Module:</td>
            <td>{{ page.endpoint_module }}</td>
          </tr>
          
          <tr v-if="page.icon">
            <td max-width="35%" class="text-subtitle-1">Icon:</td>
            <td>{{ page.icon }}</td>
          </tr>
          
          <tr v-if="page.default_param">
            <td max-width="35%" class="text-subtitle-1">Default Params:</td>
            <td>{{ page.default_param }}</td>
          </tr>
          
          <tr v-if="page.parent_id">
            <td max-width="35%" class="text-subtitle-1">Parent:</td>
            <td>
              {{ getRelationText(page.parent_id, "parent_id", "label") }}
            </td>
          </tr>
          
          <tr v-if="page.module_id">
            <td max-width="35%" class="text-subtitle-1">Module:</td>
            <td>
              {{ getRelationText(page.module_id, "module_id", "name") }}
            </td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getPage } from "@/services/page";
    
              import { getAllPages } from "@/services/page";
            
              import { getAllModules } from "@/services/module";
            

    export default {
      data() {
        return {
            id: '',
            page: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "pageEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getPage(this.id)
            .then((response) => {
              this.page = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading page");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_parent_id = {
              pageIndex: 1,
              pageSize: 100
            };
            await getAllPages(params_parent_id)
              .then(response => {
                this.relations.parent_id = response.data.content;
                return this.relations.parent_id;
              });
            
            const params_module_id = {
              pageIndex: 1,
              pageSize: 100
            };
            await getAllModules(params_module_id)
              .then(response => {
                this.relations.module_id = response.data.content;
                return this.relations.module_id;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    